import HeroSection, { FeatureSection, GuideSection, FAQSection, FeaturedArticles } from './components/HomeSections';
import SchemaOrg from '@/components/feature/SchemaOrg';
import SEOHead from '@/components/feature/SEOHead';

export default function Home() {
  return (
    <>
      <SEOHead
        title="caoliushequ官方入口 · 最新地址发布 - caoliushequ官方导航"
        description="caoliushequ是深受用户喜爱的内容社区平台，本页提供caoliushequ最新可用地址、访问指南及常见问题解答，帮助用户快速找到caoliushequ官方入口，畅享完整社区体验。"
        keywords="caoliushequ,caoliushequ最新地址,caoliushequ官方入口,caoliushequ访问教程,caoliushequ备用链接,caoliushequ社区导航,caoliushequ使用指南"
        canonical="https://nammage.cn"
        ogTitle="caoliushequ官方入口 · 最新地址发布"
        ogDescription="caoliushequ是深受用户喜爱的内容社区平台，本页提供caoliushequ最新可用地址、访问指南及常见问题解答。"
        ogUrl="https://nammage.cn"
      />

      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebSite"
        data={{
          name: 'caoliushequ官方导航',
          url: 'https://nammage.cn',
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: 'caoliushequ官方入口 - 最新地址发布',
          url: 'https://nammage.cn',
          description: 'caoliushequ官方入口导航站，提供caoliushequ最新可用地址、访问指南及常见问题解答。帮助用户快速找到caoliushequ官方入口，畅享完整社区体验。',
        }}
      />

      <main>
        <HeroSection />
        <FeatureSection />
        <FeaturedArticles />
        <GuideSection />
        <FAQSection />
      </main>
    </>
  );
}